// extracted by mini-css-extract-plugin
module.exports = {"container":"container-Dd5sP","sidebar-item":"sidebar-item-1kKtm","sidebarItem":"sidebar-item-1kKtm"};